import { render, staticRenderFns } from "./StockCategoryUnit.vue?vue&type=template&id=44ddd366&scoped=true&lang=pug"
import script from "./StockCategoryUnit.vue?vue&type=script&lang=js"
export * from "./StockCategoryUnit.vue?vue&type=script&lang=js"
import style0 from "./StockCategoryUnit.vue?vue&type=style&index=0&id=44ddd366&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ddd366",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VCombobox,VContainer,VDialog,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44ddd366')) {
      api.createRecord('44ddd366', component.options)
    } else {
      api.reload('44ddd366', component.options)
    }
    module.hot.accept("./StockCategoryUnit.vue?vue&type=template&id=44ddd366&scoped=true&lang=pug", function () {
      api.rerender('44ddd366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/stocks/categories/StockCategoryUnit.vue"
export default component.exports